import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ArrowRightIcon, BriefcaseIcon } from 'lucide-react';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-32 px-6 bg-gradient-to-b from-purple-100 to-pink-100 relative overflow-hidden" data-id="element-63">
      {/* Subtle decorative blob */}
      <motion.div animate={{
      scale: [1, 1.1, 1],
      opacity: [0.05, 0.1, 0.05]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-0 right-0 w-96 h-96 bg-purple-200/30 rounded-full blur-3xl" data-id="element-64"></motion.div>

      <div className="max-w-4xl mx-auto text-center relative" data-id="element-65">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-66">
          <h2 className="text-4xl md:text-6xl font-bold text-slate-900 mb-4" style={{
          fontFamily: 'Outfit, sans-serif',
          letterSpacing: '-0.02em'
        }} data-id="element-67">
            ¿Avanzamos?
          </h2>
          <p className="text-xl text-slate-600 mb-12" data-id="element-68">
            Elegí tu camino y comencemos a trabajar juntos
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-col sm:flex-row gap-6 justify-center items-center" data-id="element-69">
          <div className="text-center" data-id="element-70">
            <p className="text-slate-700 font-medium mb-3" data-id="element-71">Para empresas</p>
            <motion.a href="#contacto" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} className="group inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-purple-500 to-purple-600 text-white font-semibold rounded-xl shadow-lg shadow-purple-500/30 hover:shadow-xl hover:shadow-purple-500/40 transition-all duration-300" data-id="element-72">
              Quiero conversar
              <ArrowRightIcon className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-73" />
            </motion.a>
            <p className="text-sm text-slate-500 mt-3" data-id="element-74">
              Sin compromiso. Elegí canal y horario.
            </p>
          </div>

          <div className="hidden sm:block w-px h-24 bg-slate-200" data-id="element-75"></div>

          <div className="text-center" data-id="element-76">
            <p className="text-slate-700 font-medium mb-3" data-id="element-77">Para candidatos</p>
            <motion.a href="#empleo" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.98
          }} className="inline-flex items-center justify-center px-8 py-4 bg-white text-emerald-600 font-semibold rounded-xl border-2 border-emerald-500 hover:bg-emerald-50 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-78">
              <BriefcaseIcon className="mr-2 w-5 h-5" data-id="element-79" />
              Busco empleo
            </motion.a>
            <p className="text-sm text-slate-500 mt-3" data-id="element-80">
              Completá el formulario
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}